import * as React from "react";

type SegmentedControlOption = {
    value: string;
    label: string;
};

type SegmentedControlProps = {
    options: SegmentedControlOption[];
    value: string;
    onChange: (value: string) => void;
    size?: 'sm' | 'md';
};

const SegmentedControl: React.FC<SegmentedControlProps> = ({options, value, onChange, size = 'sm'}) => {
    const sizeClasses = size === 'sm'
        ? 'text-xs px-3 py-1'
        : 'text-sm px-4 py-1.5';

    return (
        <div className="inline-flex rounded-md bg-gray-100 p-0.5">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    onClick={() => onChange(option.value)}
                    className={`
                        ${sizeClasses}
                        font-medium rounded transition-all duration-150
                        ${value === option.value
                            ? 'bg-white text-gray-900 shadow-xs'
                            : 'text-gray-500 hover:text-gray-700'
                        }
                    `}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};

export default SegmentedControl;
